// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7775) return "css/Template2.443a9478-aa4a-4f6a-a515-dcb020694696.chunk.css";
	if (chunkId === 628) return "css/Template3.443a9478-aa4a-4f6a-a515-dcb020694696.chunk.css";
	if (chunkId === 9245) return "css/MobileTemplate1.443a9478-aa4a-4f6a-a515-dcb020694696.chunk.css";
	if (chunkId === 2685) return "packages/ag-grid@33.3.2/ag-grid.443a9478-aa4a-4f6a-a515-dcb020694696.bundle.css";
	if (chunkId === 2437) return "css/aiAgentV2.443a9478-aa4a-4f6a-a515-dcb020694696.chunk.css";
	if (chunkId === 7866) return "css/aiAgent.443a9478-aa4a-4f6a-a515-dcb020694696.chunk.css";
	if (chunkId === 1399) return "packages/reactflow@11.8.3/reactflow.443a9478-aa4a-4f6a-a515-dcb020694696.bundle.css";
	if (chunkId === 4149) return "packages/@wangeditor@5.0.1/@wangeditor.443a9478-aa4a-4f6a-a515-dcb020694696.bundle.css";
	if (chunkId === 3339) return "packages/icp-mining@2.3.116/icp-mining.443a9478-aa4a-4f6a-a515-dcb020694696.bundle.css";
	if (chunkId === 8309) return "css/saas-ui-chat.443a9478-aa4a-4f6a-a515-dcb020694696.chunk.css";
	if (chunkId === 5299) return "packages/icp-form-designer@2.3.116/icp-form-designer.443a9478-aa4a-4f6a-a515-dcb020694696.bundle.css";
	// return url for filenames based on template
	return undefined;
};